// firebase.ts - THIS MUST HAPPEN EARLY
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  signInWithPopup, 
  signInWithRedirect,
  getRedirectResult, // Keep export for potential direct use
  GoogleAuthProvider, 
  signOut, 
  onAuthStateChanged,
  Auth, 
} from 'firebase/auth';
import type { User } from 'firebase/auth'; 

// Your Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "auth.swayashin.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "swayashin",
};

// Check if all required config parameters are available
if (!firebaseConfig.apiKey || !firebaseConfig.authDomain || !firebaseConfig.projectId) {
  console.error("Missing Firebase configuration! Check your environment variables.");
  // Optionally throw an error or handle appropriately
}

// Log the final config being used
console.log("Using Firebase Config:", JSON.stringify(firebaseConfig));

// Initialize Firebase App
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log("Firebase App initialized:", app.name, "with Auth Domain:", firebaseConfig.authDomain);
} catch (error) {
  console.error("Firebase initialization error:", error);
  throw error; 
}

// Initialize Firebase Auth using getAuth
let auth: Auth; 
try {
  auth = getAuth(app); // Use getAuth
  console.log("Firebase Auth initialized using getAuth.");
  auth.useDeviceLanguage(); // Use browser language
} catch (error) {
  console.error("Firebase Auth initialization error:", error);
  throw error; 
}

// Additional debugging
console.log("Using Firebase auth with:", {
  authDomain: firebaseConfig.authDomain,
  appName: app.name,
  currentUser: auth.currentUser ? auth.currentUser.uid : 'No user' // Log UID if user exists
});

// Export everything needed
export {
  auth,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult, 
  signOut,
  onAuthStateChanged,
};

export type { User };
